import {
  getDetail,
  putInvestigate,
} from '@/api/detail';

export default {
  namespaced: true,
  actions: {
    // 详情
    async getDetail(context, params) {
      const { data } = await getDetail(params);
      return data;
    },

    // 是否有用
    async putInvestigate(context, params) {
      const data = await putInvestigate(params);
      return data;
    },
  },
};
